import IPrenotazione from "pages/Prenotazione/IPrenotazione";
import { formStep } from "types/StepEnums";

import { Form, ProgressBar } from "core/interfaces/components/index";
import { useCallback, useEffect } from "react";
import DataPreventivoRepository from "core/data/DataPreventivoRepository";
import i18n from "utils/i18n";
import {  IHSBLocationStateManager } from "core/interfaces/data/IHSBLocationManager";
import useSession from "utils/Session";
import NavigationManager from "utils/NavigationManager";
import { IBaseRequest } from "core/interfaces/data/Base";
import { Enhanced } from "utils/ReactUtils";

const Prenotazione: React.FC<IPrenotazione> = ({ resetForm, setResetForm, OnChangePasswordRequest, sessionInfo, location }) => {
	const { initSession, OnCloseTab } = useSession(sessionInfo);
	const { MoveStep } = NavigationManager(sessionInfo);

	const showProgersBar = () => {
		switch (sessionInfo.step) {
			case formStep.Home:
			case formStep.Area:
			case formStep.Prestazione:
			case formStep.Professionista:
			case formStep.DataPreventivo:
				return true;
			default:
				return false;
		}
	};

	const Init = async () => {
		await initSession();
		MoveStep("next");
	};

	const resetDisponibilita = useCallback(async () => {
		if ((sessionInfo.step as number) > formStep.DataPreventivo && (sessionInfo.step as number) <= formStep.SelectAssistito) {
			const props: IBaseRequest = {
				culture: i18n.language,
				IdSessione: sessionInfo.sessione!.idSessione,
				step: sessionInfo.step as number,
			};

			await DataPreventivoRepository.resetDisponibilita(props);
		}
	}, [sessionInfo.step, sessionInfo.sessione]);

	var onBeforeUnload = useCallback(
		(e: BeforeUnloadEvent) => {
			e.preventDefault();
			resetDisponibilita();
		},
		[resetDisponibilita]
	);

	var onUnload = useCallback(async () => {
		await OnCloseTab(sessionInfo.step as number);
	}, [OnCloseTab, sessionInfo.step]);

	useEffect(() => {
		if (location?.state) {
			let state = location.state as IHSBLocationStateManager;

			if (state?.reset ?? false) {
				resetDisponibilita();
			}

			// sezione per intercettare la dismissione della pagina corrente,
			// non funziona sempre correttamente alla chiusura della pagina
			// se dismetto la pagina in maniera "standard" con F5 per eesempio ripristino i blocchetti altrimenti
			// ci pensa lato server alla dismissione della sessione

			window.addEventListener("beforeunload", onBeforeUnload);
			window.addEventListener("unload", onUnload);
			return () => {
				window.removeEventListener("beforeunload", onBeforeUnload);
				window.removeEventListener("unload", onUnload);
			};
		}
	}, [location, onBeforeUnload, onUnload, resetDisponibilita]);

	return (
		<>
			<div className="progress-bar-container">{showProgersBar() && <ProgressBar current={sessionInfo.step as number} />}</div>

			<div className="current-form">
				<Form InitSession={Init} resetForm={resetForm} setResetForm={setResetForm} OnChangePasswordRequest={OnChangePasswordRequest} />
			</div>
		</>
	);
};
export default Enhanced(Prenotazione, {});
